module.exports = __webpack_public_path__ + "static/java-3cab66535249d745ee0a342ad2a9c50f.jpg";